import { useTypes } from '../../hooks/useVault';

/** Small colour dot for a note type, colour from the type schema. */
export function TypeDot({ type, size = 7 }: { type: string; size?: number }) {
  const types = useTypes();
  const def = types.data?.find((t) => t.key === type);
  const colour = def?.colour ?? 'var(--text-faint)';
  return <span className="type-dot" title={def?.label ?? type} style={{ width: size, height: size, borderRadius: '50%', background: colour, display: 'inline-block', flex: 'none' }} />;
}
